import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useReducedMotion } from '../../motion/useReducedMotion';
import { springSheet } from '../../motion/springs';
import './ui.css';

const backdropVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

const sheetVariants = {
  initial: { y: '100%' },
  animate: { y: 0, transition: springSheet },
  exit: { y: '100%', transition: { duration: 0.2 } },
};

const sheetVariantsReduced = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export function Sheet({ open, onClose, children, showHandle = true }) {
  const reducedMotion = useReducedMotion();

  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (event) => {
      if (event.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  const variants = reducedMotion ? sheetVariantsReduced : sheetVariants;

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            className="ui-sheet-backdrop"
            variants={backdropVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            onClick={onClose}
            aria-hidden="true"
          />
          <motion.div
            className="ui-sheet"
            role="dialog"
            aria-modal="true"
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            {showHandle && <div className="ui-sheet-handle" aria-hidden="true" />}
            {children}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}

export default Sheet;
